module.exports = __webpack_public_path__ + "static/media/practice-2.02159e64.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/practice-2.png
// module id = 623
// module chunks = 0